import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Contents Information Swiper（benavi / ntmnavi トップ共通）
// 画面に入ったら遅延初期化する
//
// 注意: Swiper v12 + slidesPerView: 'auto' + loop:true は
// スライド数が少ない（≒ slidesPerView * 2 程度）と loop が無効化される。
// そのため init 前に wrapper 内のスライドを必要数だけ複製しておく。
export const initInfoSwiper = () => {
  const target = document.querySelector('.info-swiper');
  if (!target) return;

  let swiper = null;

  const initialize = () => {
    if (swiper) return;

    // ----- ループ用に DOM 上のスライドを必要数まで複製 -----
    const wrapper = target.querySelector('.swiper-wrapper');
    const originalSlides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
    const originalCount = originalSlides.length;
    // Swiper v12 では概ね slidesPerView*2 + 余裕が必要。8 あれば 'auto' でも安全
    const MIN_FOR_LOOP = 8;
    if (originalCount > 0 && originalCount < MIN_FOR_LOOP) {
      const rounds = Math.ceil(MIN_FOR_LOOP / originalCount) - 1;
      for (let i = 0; i < rounds; i++) {
        originalSlides.forEach((slide) => {
          const clone = slide.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.dataset.duplicate = 'true';
          wrapper.appendChild(clone);
        });
      }
    }

    swiper = new Swiper('.info-swiper', {
      modules: [Autoplay, Pagination, Navigation],
      loop: true,
      loopAdditionalSlides: 1,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        waitForTransition: false,
      },
      grabCursor: true,
      allowTouchMove: false,
      simulateTouch: false,
      effect: 'slide',
      pagination: {
        el: '.info-pagination',
        clickable: true,
        // 複製スライド分の bullet は描画しない（元のスライド数分だけ表示）
        renderBullet: (index, className) => {
          if (index >= originalCount) return '';
          return `<span class="${className}"></span>`;
        },
      },
      navigation: {
        nextEl: '.info-nav .swiper-button-next',
        prevEl: '.info-nav .swiper-button-prev',
      },
      slidesPerView: 1.2,
      spaceBetween: 65,
      centeredSlides: true,
      roundLengths: true,
      speed: 400,
      breakpoints: {
        768: { slidesPerView: 'auto', spaceBetween: 65, centeredSlides: false },
        320: { slidesPerView: 1, centeredSlides: true, spaceBetween: 21 },
      },
      on: {
        // 複製スライドが active の時、対応する元 bullet を active にする
        slideChange: function () {
          if (!this.pagination?.bullets?.length) return;
          const activeIdx = this.realIndex % originalCount;
          this.pagination.bullets.forEach((b, i) => {
            b.classList.toggle('swiper-pagination-bullet-active', i === activeIdx);
          });
        },
      },
    });
    observer.disconnect();
  };

  const observer = new IntersectionObserver((entries) => {
    if (entries.some(entry => entry.isIntersecting)) initialize();
  }, { threshold: 0.01 });

  observer.observe(target);
};
